function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from "react";
import { isFunction } from "lodash";
import reactDom from "react-dom";
import rerenderOnWindowResize from "./rerenderOnWindowResize";
import "./FillWindow.css"; // use like:
// <FillWindow>
//         {({ width, height }) => {
//           return <div style={{width, height}}></div>
//         }
// <FillWindow/>

var FillWindow = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FillWindow, _React$Component);

  function FillWindow(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    rerenderOnWindowResize(_assertThisInitialized(_this));
    return _this;
  } // this is left here for posterity. componentDidMount didn't work before commit ee1853a5ae2e6e27b720dd225650cc2154076db5 "fixing rerenderOnWindowResize to bind this keyword correctly"
  // componentDidMount(){
  //   this.setState({thomas: "realCool"})
  // }


  var _proto = FillWindow.prototype;

  _proto.render = function render() {
    var w = window,
        d = document,
        e = d.documentElement,
        g = d.getElementsByTagName("body")[0],
        width = w.innerWidth || e.clientWidth || g.clientWidth,
        height = w.innerHeight || e.clientHeight || g.clientHeight;
    var windowDimensions = {
      width: width,
      height: height
    };

    var _this$props = this.props,
        _this$props$container = _this$props.containerStyle,
        containerStyle = _this$props$container === void 0 ? {} : _this$props$container,
        style = _this$props.style,
        styleOverrides = _this$props.styleOverrides,
        className = _this$props.className,
        asPortal = _this$props.asPortal,
        rest = _objectWithoutPropertiesLoose(_this$props, ["containerStyle", "style", "styleOverrides", "className", "asPortal"]);

    if (this.props.disabled) return this.props.children(windowDimensions);
    var inner = /*#__PURE__*/React.createElement("div", _extends({
      className: "tg-fillWindow " + (asPortal ? "bp3-portal " : "") + (className || ""),
      style: _extends({}, style, {
        width: width,
        height: height,
        position: "fixed",
        top: 0,
        left: 0
      }, containerStyle, styleOverrides)
    }, rest), this.props.children && isFunction(this.props.children) ? this.props.children(windowDimensions) : this.props.children);
    if (asPortal) return reactDom.createPortal(inner, window.document.body);
    return inner;
  };

  return FillWindow;
}(React.Component);

export { FillWindow as default };